import React from 'react';
import { Link } from 'gatsby';
import styled from '@emotion/styled';
import Headroom from 'react-headroom';
import logo from '../../static/logo/redboost-logo.png';

const StyledLink = styled(Link)`
  display: flex;
  font-weight: 700;
  align-items: center;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: flex-end;
  font-family: ${props => props.theme.fontFamily.body};
  font-weight: 500;
  font-size: 1.1rem;
  align-items: center;
  a {
    color: ${props => props.theme.colors.white.base};
    margin-left: 2rem;
    transition: all ${props => props.theme.transitions.default.duration};
    &:hover {
      color: ${props => props.theme.colors.white.grey};
    }
  }

  @media (max-width: 320px) {
    /* margin: 4rem 1rem 1rem 1rem; */
    padding-bottom: 100px;
    height: 50%;
    a {
    color: ${props => props.theme.colors.white.base};
    margin-left: 2rem;
    transition: all ${props => props.theme.transitions.default.duration};
      &:hover {
        color: ${props => props.theme.colors.white.grey};
      }
    }
  }
  @media (max-width: 375px) {
    /* margin: 4rem 1rem 1rem 1rem; */
    padding-bottom: 100px;
    height: 50%;
    a {
    color: ${props => props.theme.colors.white.base};
    margin-left: 2rem;
    transition: all ${props => props.theme.transitions.default.duration};
      &:hover {
        color: ${props => props.theme.colors.white.grey};
      }
    }
  }

  @media (max-width: 425px) {
    /* margin: 4rem 1rem 1rem 1rem; */
    padding-bottom: 100px;
    height: 50%;
    a {
    color: ${props => props.theme.colors.white.base};
    margin-left: 2rem;
    transition: all ${props => props.theme.transitions.default.duration};
      &:hover {
        color: ${props => props.theme.colors.white.grey};
      }
    }
  }
`;
const ImageItem = styled.img`
  width: 10rem;
  height: 10rem;
  @media (max-width: 320px) {
    width: 12rem;
    height: 12rem;
  }  
  @media (max-width: 375px) {
    width: 12rem;
    height: 12rem;
  }
  @media (max-width: 425px) {
    width: 6rem;
    height: 6rem;
  }
  
`
const NavBar = () => (
  <Headroom calcHeightOnResize disableInlineStyles>
    <StyledLink to="/">
      <ImageItem src={logo} alt="RedBoost Logo" />
    </StyledLink>
    <Nav className="navbar navbar-expand-lg">
      <div className="collapse navbar-collapse">
        <ul className="navbar-nav mr-auto">
          <li className="nav-item active">
            <Link to="/">Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/products">Products</Link>
          </li>
          <li className="nav-item">
            <Link to="/about">Contact</Link>
          </li>
        </ul>
      </div>
    </Nav>
  </Headroom>
);

export default NavBar;
